module.exports = __webpack_public_path__ + "static/media/fisioterapia.3f3e4679.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/iconos/fisioterapia.png
// module id = 91
// module chunks = 0